'use strict';

const utils = require('../utils');
module.exports = {
    onApplyCouponCode: function () {
        $(document).on('click', '.js-apply-code', (e) => {
            const element = e.target;
            const promoId = element.getAttribute('data-promoid');
            // eslint-disable-next-line
            let url_value = element.getAttribute('data-add-coupon-line-url');
            const params = utils.getQueryStringParams(url_value);
            // eslint-disable-next-line
            const code_val = params.couponCode;
            const csrfToken = $('.csrf-token').val();
            // eslint-disable-next-line
            let url = `${url_value}&csrf_token=${csrfToken}`;
            $.ajax({
                url: url,
                method: 'GET',
                dataType: 'json',
                success: function (data) {
                    const { discounts } = data.totals;
                    // eslint-disable-next-line
                    const filteredItem = discounts.filter(item => item.couponCode===code_val);
                    if (!filteredItem.length) {
                        return;
                    }
                    const applyCodeButtons = document.querySelectorAll('.js-apply-code');
                    [...applyCodeButtons].forEach(item => {
                        const id = item.getAttribute('data-promoid');
                        if (id === promoId) {
                            $('#promo-' + id).addClass('d-none');
                            $('#applied-' + id).removeClass('d-none');
                        } else {
                            $('#promo-' + id).attr('disabled', true);
                        }
                    });
                }
            });
        });
    }
};
